import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, ResearcherEventAttentionTask } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UsePostAttentionTaskProps = {
  id: number
}

export type AttentionTaskData = {
  message: string
}

export const usePostAttentionTask = ({
  id,
}: UsePostAttentionTaskProps): UseMutationResult<
  ResearcherEventAttentionTask,
  APIErrorResponse,
  AttentionTaskData
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (data: AttentionTaskData) =>
      client
        .post(`plannings/events/manager/${id}/create_attention_task/`, data)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([QUERY_KEYS.ATTENTION_TASKS, id])
      },
    }
  )
}
